module.exports = __webpack_public_path__ + "static/gorou-4cee251ae19ab023b4b8f72b0d7f05b4.png";